import React from 'react'

import { BsCopy } from 'react-icons/bs'

import Card from './card/index'
import { SectionProgressType } from '../../../types/components'

import { ContentSectionProgress, ContentCards } from './styles'

const SectionProgress = ({ sectionProgressData }: SectionProgressType) => {
  return (
    <ContentSectionProgress>
      <ContentCards>
        {sectionProgressData &&
          sectionProgressData.map((data, i) => (
            <Card
              key={i}
              Icon={data.icon || BsCopy}
              amount={data.amount}
              title={data.amountTitle}
              hoverText={data?.hoverText}
            />
          ))}
      </ContentCards>
    </ContentSectionProgress>
  )
}

export default SectionProgress
